export default __webpack_public_path__ + "static/media/Oval-Hall.540bd750.jpg";